import { useContext } from 'react';
import { FieldContext } from './FieldContext';
export default function FormLabel({children,htmlFor,error,className,id}:any) {
    const field=useContext(FieldContext);
    return <label id={id} htmlFor={htmlFor || field?.id} className={`form-label form-label-custom ${(error ?? field?.error) ? 'text-danger' : ''} ${className || ''}`}>{children}</label>;
}
